import { LayerType } from "../Player/LayerType";

/**
 * Bild- oder Video-Ebene OHNE Datei — im Template-Editor auf „Entfernen"
 * geklickt, oder eine frisch angelegte Ebene ohne Upload.
 *
 * WARUM DAS HIER STEHT (Jans Fund 05.08.2026: „Video geloescht, der Ton laeuft
 * weiter" und „Bild geloescht, im Renderer bleibt es stehen"): `updateImage`
 * und `updateVideo` verstecken das Mesh und pausieren das Video — EINMAL. Der
 * Bild-fuer-Bild-Durchlauf (`renderLayer`) rechnet die Sichtbarkeit danach aus
 * Lebensdauer und Auge neu und startet die Wiedergabe wieder. Beide Eingriffe
 * waren also schon im naechsten Bild zurueckgenommen.
 */
export function istLeererMedienSlot(inhalt: unknown, typ: unknown): boolean {
    if (typ !== LayerType.image && typ !== LayerType.video) return false;
    const c = inhalt as { url?: unknown; ppiUrl?: unknown } | undefined;
    const gefuellt = (w: unknown) => typeof w === "string" && w.trim().length > 0;
    return !gefuellt(c?.ppiUrl) && !gefuellt(c?.url);
}
